import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {AListItem} from "@cisco-sbg-ui/magna-react";
import {useDispatch} from "react-redux";
import {INCIDENT_ACTIONS} from "../../../models/options";
import {setLinkingIncidents} from "../../../store/features/incidentsSlice";

const BulkActionLinkMenuItem = ({
  incidents = [],
  primaryLinkIncident,
  setPrimaryLinkIncident
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (incidents.length > 1) {
      const primaryIncident = incidents[0]
        ? {value: incidents[0].id, label: incidents[0].title}
        : null;
      setPrimaryLinkIncident(primaryIncident);
    }
  }, [incidents, setPrimaryLinkIncident]);

  const handleIncidentLinking = async () => {
    if (
      incidents.length < 2 ||
      !primaryLinkIncident ||
      !primaryLinkIncident.value
    )
      return;

    const target =
      incidents.find((inc) => inc.id === primaryLinkIncident.value)?.id ||
      incidents?.[0].id;

    const sources = incidents
      .filter((inc) => inc.id !== primaryLinkIncident.value)
      .map((inc) => inc.id);

    dispatch(setLinkingIncidents({target, sources}));
  };

  return (
    <AListItem
      data-testid={"BulkActionLinkMenuItem-ListItem"}
      id={INCIDENT_ACTIONS.Link.name}
      className="bulk-action__link-incidents-item"
      disabled={incidents.length < 2}
      onClick={() => handleIncidentLinking()}>
      {INCIDENT_ACTIONS.Link.name}
    </AListItem>
  );
};

BulkActionLinkMenuItem.propTypes = {
  incidents: PropTypes.array,
  primaryLinkIncident: PropTypes.object,
  setPrimaryLinkIncident: PropTypes.func,
  handleUnselectAll: PropTypes.func
};

export default BulkActionLinkMenuItem;
